import type { Feature } from '@luna/gatekeeper';

export const accountLinkage: Feature = {
    enabled: true,
    _description: 'Displays account linkage card on the bank card settings page',
};
